import {fetchApi} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import resetError from 'shared/errorHandler/actions/resetError'
import * as types from './types'

export default (params) => dispatch => {
    dispatch({type: types.GET_FLIGHT_WEATHER_START})
    dispatch(resetError())
    return fetchApi('/api/fb/weather/flight/' + params)
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_FLIGHT_WEATHER_SUCCESS, response: response
            })
        }).catch(error => {
            dispatch({
                type: types.GET_FLIGHT_WEATHER_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading weather.'}))
        })
}

export const handler_GET_FLIGHT_WEATHER_START = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: true,
        data: undefined
    })
}

export const handler_GET_FLIGHT_WEATHER_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: action.response.Airports || []
    })
}

export const handler_GET_FLIGHT_WEATHER_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        isLoading: false,
        data: undefined
    })
}

actionMap[types.GET_FLIGHT_WEATHER_START] = handler_GET_FLIGHT_WEATHER_START
actionMap[types.GET_FLIGHT_WEATHER_SUCCESS] = handler_GET_FLIGHT_WEATHER_SUCCESS
actionMap[types.GET_FLIGHT_WEATHER_FAILURE] = handler_GET_FLIGHT_WEATHER_FAILURE


// WEBPACK FOOTER //
// ./src/screens/briefing/weather/actions/getFlightWeather.js